import { forwardRef } from 'react';
import { CommonFormFieldProps } from '../CommonFormField';
import { FooterButton } from '../../DatePicker';
import { DueDatePicker, DueDatePickerProps } from '../../DueDatePicker';
import { DueDateFormField } from './DueDateFormField';

const FOOTER_BUTTONS: FooterButton[] = [
  FooterButton.Overdue,
  FooterButton.Today,
  FooterButton.Next7Days,
  FooterButton.Next14Days,
  FooterButton.Next30Days,
];

export type DueDateFilterFieldProps = Omit<DueDatePickerProps, 'error' | 'rfiCreatedAt'> &
  Pick<CommonFormFieldProps, 'required' | 'error' | 'loading'> & {
    rfiCreatedAt?: DueDatePickerProps['rfiCreatedAt'];
  };

const nowInIsoString = new Date().toISOString();

export const DueDateFilterField = forwardRef<HTMLDivElement, DueDateFilterFieldProps>(
  (
    {
      required,
      error,
      'data-testId': dataTestId = 'DueDateFilterField',
      loading = false,
      rfiCreatedAt = nowInIsoString,
      ...datePickerProps
    },
    ref,
  ) => (
    <DueDateFormField
      required={required}
      error={error}
      data-testid={dataTestId}
      loading={loading}
      rfiCreatedAt={rfiCreatedAt}
      ref={ref}
    >
      <DueDatePicker
        range
        footerButtons={FOOTER_BUTTONS}
        rfiCreatedAt={rfiCreatedAt}
        error={!!error}
        {...datePickerProps}
      />
    </DueDateFormField>
  ),
);
